import axios from 'axios';
import { auth } from "@/firebase";
const { getFunctionUrl } = require('../../functions/functionsConfig');

const AUDIT_LOG_API_BASE_URL = getFunctionUrl('send_audit_log_event');

const sendAuditLogEvent = async (product_action, target_type, target_id) => {
  try {
    const audit_log_endpoint = `${AUDIT_LOG_API_BASE_URL}/log_event`;
    const audit_log_payload = {
      "actor_id": auth.currentUser.uid, // this user is the actor
      "product_action": product_action, // this is the action that the actor is performing  
      "target_type": target_type, // this is the type of the target (source they are acting upon)
      "target_id": target_id // this is the id of the target
    };

    console.log('audit_log_payload', audit_log_payload);

    const audit_log_response = await axios.post(audit_log_endpoint, audit_log_payload);
    console.log('response from audit log', audit_log_response);
  } catch (error) {
    console.error('Error sending audit log event', error);
    throw error;
  }
};

export default {
  sendAuditLogEvent
}
